// extracted by mini-css-extract-plugin
export default {"featuredPosts":"Feed-module--featuredPosts--ItRBw","posts":"Feed-module--posts--a3QW9","heading":"Feed-module--heading--ZuOnu","loadMore":"Feed-module--loadMore--fr-5H"};